module.exports = __webpack_public_path__ + "img/logo.4eef540b.png";